import cn from 'classnames';

import { Toolbar } from 'features/Editor';

import styles from './FixedToolbar.module.scss';

export function FixedToolbar(props: React.ComponentProps<typeof Toolbar>) {
	return <Toolbar {...props} className={cn(styles.toolbar, props.className)} />;
}
